import { UPDATE_CREDENTIALS, UPDATE_CONTACT_DATA, UPDATE_SOCKET_TOKEN } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    code: localStorage.getItem("code") || null,
    email: localStorage.getItem("email") || null,
    contactData: null,
    socketToken: localStorage.getItem("socket_token") || null,
};

const updateCredentials = (state, action) => {
    return updateState(state, {
        code: action.code,
        email: action.email,
    });
};

const updateContactData = (state, action) => {
    return updateState(state, {
        contactData: action.contactData,
    });
};

const updateSocketToken = (state, action) => {
    return updateState(state, {
        socketToken: action.socketToken,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_CREDENTIALS:
            return updateCredentials(state, action);
        case UPDATE_CONTACT_DATA:
            return updateContactData(state, action);
        case UPDATE_SOCKET_TOKEN:
            return updateSocketToken(state, action);
        default:
            return state;
    }
};

export default reducer;
